import React, {useMemo} from 'react';
import {Checkbox, FormControlLabel, Typography, makeStyles} from '@material-ui/core';
import Panel from '../../../../../components/UI/DashboardPanel/Panel';
import {PanelTitle} from '../../../../../components/UI/DashboardPanel/PanelTitle';
import NoInfoOverlay from '../../../../../components/UI/DashboardPanel/NoInfoOverlay';
import {useTranslation} from 'react-i18next';
import {useDataRequirements} from 'apps/web-portal-ui/src/app/hooks/useDataRequirements';
import {IOrganizationEntity} from '@deep-planet/api-interfaces';

const useStyles = makeStyles({
  label: {
    color: 'black',
  },
  container: {
    height: '90%',
    display: 'flex',
    flexDirection: 'column',
  },
});

interface Props {
  selectedOrganization: IOrganizationEntity;
  isMobile: boolean;
}

const DataRequirementsPanel = ({selectedOrganization, isMobile}: Props) => {
  const {t} = useTranslation();
  const classes = useStyles();

  const {dataRequirements, loadingDataRequirements, errorDataRequirements} = useDataRequirements(selectedOrganization);

  const requirementEntries = useMemo(() => Object.entries(dataRequirements || {}), [dataRequirements]);

  return (
    <Panel width="50%" height="200px" right={!isMobile}>
      <PanelTitle>{t('data.requirements')}</PanelTitle>
      <div className={classes.container}>
        {errorDataRequirements || loadingDataRequirements || !requirementEntries.length ? (
          <NoInfoOverlay name={t('data.requirements')} variant="body2" />
        ) : (
          requirementEntries.map(([key, value]) => (
            <FormControlLabel
              key={key}
              control={<Checkbox disabled checked={value} color="primary" disableRipple disableFocusRipple disableTouchRipple />}
              label={
                <Typography variant="body1" className={classes.label}>
                  {t(`data.requirements.${key}`)}
                </Typography>
              }
            />
          ))
        )}
      </div>
    </Panel>
  );
};

export default React.memo(DataRequirementsPanel);
